<article *ngIf="caseStudy">
    <div class="cs__intro position-relative w-100 d-flex justify-content-center align-items-center">
        <div class="cs__intro__box position-absolute p-4 text-white">
            <h1 class="ff-spectral fs-4 fw-bold text-white mb-3">{{ caseStudy.title }}</h1>
            <div class="cs__intro__list">
                <p class="fs-6 mb-2" *ngFor="let product of caseStudy.products">{{ product.name }}</p>
            </div>
        </div>
        <img class="image-as-bg" [src]="caseStudy.bannerUrl" [appScrset]="caseStudy.bannerUrl" [width]="1920">
    </div>

    <div class="container py-5">
        <div class="row">
            <div class="col-12 col-md-5 col-xl-4 col-xxl-4 offset-xxl-1 px-xxl-5 mb-4 mb-md-0">
                <div class="cs__key-facts w-100 h-100 bg-primary p-3 p-lg-5">
                    <div class="cs__key-facts__title fs-4 ff-spectral text-white pb-4 mb-0">Key Facts</div>
                    <div class="cs__key-fact d-flex flex-column flex-xl-row w-100 py-3 text-white">
                        <span class="cs__key-fact__title mb-2 mb-xl-0">Project:</span>
                        <span class="cs__key-fact__content fw-bolder">{{ caseStudy.title }}</span>
                    </div>
                    <div class="cs__key-fact d-flex flex-column flex-xl-row w-100 py-3 text-white">
                        <span class="cs__key-fact__title">Location:</span>
                        <span class="cs__key-fact__content fw-bolder">{{ caseStudy.location }}</span>
                    </div>
                    <div class="cs__key-fact d-flex flex-column flex-xl-row w-100 py-3 text-white">
                        <span class="cs__key-fact__title">Budget:</span>
                        <span class="cs__key-fact__content fw-bolder">&pound; {{ caseStudy.budget }}</span>
                    </div>
                    <div class="cs__key-fact d-flex flex-column flex-xl-row w-100 py-3 text-white">
                        <span class="cs__key-fact__title">Quantity:</span>
                        <span
                            class="cs__key-fact__content fw-bolder">{{ caseStudy.quantity }} {{ caseStudy.quantityUnit }}</span>
                    </div>
                    <div class="cs__key-fact d-flex flex-column flex-xl-row w-100 py-3 text-white">
                        <span class="cs__key-fact__title">Products used:</span>
                        <div class="cs__key-fact__content fw-bolder d-flex flex-column">
                            <a class="text-white" *ngFor="let product of caseStudy.products"
                               [href]="['products/' + product.slug]">{{ product.name }}</a>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="(deviceType$| async) !== 'mobile'" class="col-12 col-md-7 col-xl-8 col-xxl-6">
                <div class="fs-3 ff-spectral text-primary mb-4">{{ caseStudy.previewParagraph }}</div>
                <div class="text-primary" [innerHTML]="caseStudy.content"></div>
            </div>
        </div>
    </div>

    <aside>
        <app-case-study-public-slider [images]="caseStudy.images"></app-case-study-public-slider>
    </aside>

    <div *ngIf="(deviceType$| async) === 'mobile'" class="container container--article">
        <div class="fs-3 ff-spectral text-primary mb-4">{{ caseStudy.previewParagraph }}</div>
        <div class="text-primary" [innerHTML]="caseStudy.content"></div>
    </div>

    <app-share-icons></app-share-icons>

    <div *ngIf="caseStudy.products.length">
        <app-case-study-public-related-products
            [products]="caseStudy.products"
        ></app-case-study-public-related-products>
    </div>

    <app-trustpilot-review-slider></app-trustpilot-review-slider>

    <app-contact-cta></app-contact-cta>
</article>


<!--
<div class="container-fluid p-4" *ngIf="caseStudy">
    <div class="container-fluid" *ngIf="caseStudy.productRanges.length">
        <h1 class="mb-50">Products used in this case study</h1>
        <div class="row">
            <div class="col-md-6" *ngFor="let pg of caseStudy.productRanges">
                <div class="group-preview-tile">
                    <div *ngIf="pg.imageUrl" class="bg-image hover"
                         [routerLink]="['/product-ranges', pg.slug]"
                         [ngStyle]="{'background-image': 'url(' + pg.imageUrl + ')'}"></div>
                    <div *ngIf="!pg.imageUrl" class="bg-image hover"
                         [routerLink]="['/product-ranges', pg.slug]"
                         [ngStyle]="{'background-image': 'url(' + 'assets/images/no-image.png' + ')'}"></div>
                    &lt;!&ndash;                <img *ngIf="pg.imageUrl" [src]="pg.imageUrl" class="img-fluid" />&ndash;&gt;
                    &lt;!&ndash;                <img *ngIf="!pg.imageUrl" src="assets/images/no-image.png" class="img-fluid" />&ndash;&gt;
                    <p class="group-name mt-3">{{pg.name}}</p>
                    <p class="group-description" [innerHTML]="pg.description"></p>
                    <p class="group-price">
                        <span *ngIf="pg.hasProducts">Prices from {{pg.pricesFrom | currency: 'GBP'}}</span>
                        <span *ngIf="!pg.hasProducts">(No products)</span>
                    </p>
                    <a class="btn btn-primary" [routerLink]="['/product-ranges', pg.slug]">
                        View the range
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
-->
